// Contenedores predefinidos (colores y estilo segun las guias de AWS). Cualquier servicio tambien puede
// ser contenedor (data.contenedor): una EC2 que contiene una base de datos, etc.
export const GRUPOS = {
    nube: { label: "AWS Cloud", color: "#232F3E", dash: "", w: 760, h: 520 },
    cuenta: { label: "Cuenta AWS", color: "#E7157B", dash: "6 4", w: 700, h: 480 },
    region: { label: "Región", color: "#00A4A6", dash: "6 4", w: 640, h: 440 },
    vpc: { label: "VPC", color: "#8C4FFF", dash: "", w: 560, h: 380 },
    "subnet-pub": { label: "Subred pública", color: "#7AA116", dash: "", w: 260, h: 240 },
    subnet: { label: "Subred privada", color: "#00A4A6", dash: "", w: 260, h: 240 },
    asg: { label: "Auto Scaling group", color: "#ED7100", dash: "6 4", w: 300, h: 220 },
    onprem: { label: "Centro de datos", color: "#7D8998", dash: "", w: 300, h: 220 },
    capa: { label: "Capa (carpeta)", color: "#0d6efd", dash: "8 4", w: 600, h: 400 },
    generico: { label: "Grupo", color: "#879196", dash: "4 3", w: 300, h: 220 },
};
